import * as React from 'react';
import { TextField, Grid } from '@material-ui/core';
import { contact } from '../../../model/contact';
import { IChatMessage } from '../../../model/chatmessage';
import { Guid } from 'guid-typescript';
import { profile } from '../../../model/profile';
import Button from '../../../ui-components/Button/Button';

interface IProps {
    contact: contact;
    addMessage: (chatmessage: IChatMessage) => void;
    chatMessages: Array<IChatMessage>;
    profile: profile;
    smallScreen: boolean;
    classes: any;
    messageContainerHeigth: string;
    messageBoxRef: any;
}

interface IState {
    messageOut: string;
    myConnectionId: string;
    chatmessage: IChatMessage;
}

export class WriteYourMessage extends React.Component<IProps, IState> {

    messagesEnd: HTMLDivElement;
    constructor(props: IProps) {
        super(props);
        this.state = {
            messageOut: ``,
            myConnectionId: ``,
            chatmessage: {
                _id: ``,
                createdAt: null,
                text: ``,
                fromAdmin: true,
                user: undefined
            },
        }
    }


    private sendMessage = () => {
        if (this.state.messageOut && this.state.messageOut.trim()) {
            if (this.props.contact.sub) {
                console.log('Admin sta per mandare il messaggio con Testo....:' + this.state.messageOut + ' ad utente con Sub:' + this.props.contact.sub);

                const newmessage: IChatMessage = {
                    _id: Guid.create().toString(),
                    text: this.state.messageOut,
                    createdAt: new Date(),
                    user: { _id: this.props.contact.sub },  // il sub del destinatario
                    fromAdmin: true
                }
                this.props.addMessage(newmessage);

            } else {
                console.error('Admin vorrebbe mandare il messaggio con Testo:' + this.state.messageOut + ' ma non abbiamo il suo Sub')
            }
            // Pulizia del campo dopo l'invio
            this.setState({ messageOut: `` })
        }
    }

    private handleChangeMessage = (event: any) => {
        this.setState({ messageOut: event.target.value })
    }

    scrollToBottom = () => {
        if (this.messagesEnd)
            this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }

    keyDown = (e) => {
        if (e.keyCode === 13) {
            this.sendMessage();
        }
    }
    render() {
        // let contact = this.props.contact ? this.props.contact : emptyContact();
        return (<>
            <Grid container spacing={1} className={this.props.classes.sendMessageBox}>
                <Grid item xs={10}>
                    <TextField
                        placeholder='scrivi un messaggio'
                        fullWidth
                        color="secondary"
                        multiline
                        value={this.state.messageOut}
                        onChange={this.handleChangeMessage}
                        onKeyDown={this.keyDown}
                    />
                </Grid>
                <Grid item xs={2}>
                    <Button disabled={!this.state.messageOut || !this.state.messageOut.trim()} onClick={this.sendMessage} className={this.props.classes.btnInvia}>
                        Invia</Button>
                </Grid>
            </Grid>
        </>
        )
    }
}
